const supportsLocalStorage = typeof localStorage !== 'undefined';
const prefix = 'nv-communicator-';
const get = (item) => {
    if (!supportsLocalStorage) {
        return false;
    }
    const name = `${prefix}${item}`;
    const value = localStorage.getItem(name);
    if (!value) {
        return undefined;
    }
    return JSON.parse(value);
};
const set = (item, value) => {
    if (!supportsLocalStorage) {
        return false;
    }
    const name = `${prefix}${item}`;
    return localStorage.setItem(name, JSON.stringify(value));
};
const remove = (item) => {
    if (!supportsLocalStorage) {
        return false;
    }
    const name = `${prefix}${item}`;
    return localStorage.removeItem(name);
};
const clear = () => {
    if (!supportsLocalStorage) {
        return false;
    }
    return localStorage.clear();
};
const nvStorage = {
    get,
    set,
    remove,
    clear,
};
export default nvStorage;
